import { Link } from "react-router-dom";

function CheckEmailPage() {
  return (
    <main className="AuthPage" style={{ maxWidth: "378px", margin: "0 auto", width: "100%", boxSizing: "border-box", padding: "0 16px" }}>
      <h1>Check Your Email</h1>
      <p style={{ opacity: 0.85, marginBottom: "16px" }}>
        We sent a verification link to your email address. Please click the link to verify your account before logging in.
      </p>
      <p style={{ opacity: 0.85, fontSize: "13px", marginBottom: "24px" }}>
        Didn't receive it? Check your spam folder. The link expires in 24 hours.
      </p>
      <p>
        Already verified? <Link to="/login">Log in</Link>
      </p>
    </main>
  );
}

export default CheckEmailPage;